exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ChatModal__modal {\n  padding: 0;\n}\n.ChatModal__thread {\n  height: 80vh;\n}\n@media (min-width: 768px) {\n.ChatModal__thread {\n    height: 90vh;\n}\n}\n", ""]);

// exports
